import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import type { AtlasResponse, ConfigResponse, DeviceIdentity, LocalResponse, PublicDilemma } from './types';

export interface AppState {
  config: ConfigResponse | null;
  device: DeviceIdentity | null;
  dilemma: PublicDilemma | null;
  atlas: AtlasResponse | null;
  history: LocalResponse[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  setConfig: (config: ConfigResponse) => void;
  setDevice: (device: DeviceIdentity) => void;
  setDilemma: (dilemma: PublicDilemma | null) => void;
  setAtlas: (atlas: AtlasResponse) => void;
  setHistory: (history: LocalResponse[]) => void;
  setLoading: (loading: boolean) => void;
  setSaving: (saving: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAppStore = create<AppState>()(immer((set) => ({
  config: null,
  device: null,
  dilemma: null,
  atlas: null,
  history: [],
  loading: true,
  saving: false,
  error: null,
  setConfig: (config) => set((state) => { state.config = config; }),
  setDevice: (device) => set((state) => { state.device = device; }),
  setDilemma: (dilemma) => set((state) => { state.dilemma = dilemma; }),
  setAtlas: (atlas) => set((state) => { state.atlas = atlas; }),
  setHistory: (history) => set((state) => { state.history = history; }),
  setLoading: (loading) => set((state) => { state.loading = loading; }),
  setSaving: (saving) => set((state) => { state.saving = saving; }),
  setError: (error) => set((state) => { state.error = error; })
})));
